import React from "react";
import Page from "../templates/support/childrin&education/spotlight/clean-drinking-water-for-children";

export default function home() {
  return (
    <div>
      <Page />
    </div>
  );
}
